import { Environment } from '@nimmsta/ng-commons-lib';

export const environment = {
  production: false,
  environment: Environment.PROD,
  apiUrls: {
    b2b: 'https://backend.b2b-prod.nimmsta.com',
    workflow: 'https://backend.cloud.nimmsta.com',
    configurations: 'https://backend.configurator.nimmsta.com',
    auth: 'https://auth.nimmsta.com',
  },
  applicationUrls: {
    workflow: 'https://cloud.nimmsta.com',
    configurations: 'https://configurator.nimmsta.com',
  },
  defaultPageSize: 20,
  defaultPageSizeOptions: [10, 20, 50, 100],
  keycloakUrl: 'https://auth.nimmsta.com',
  keycloakRealm: 'productivity-cloud',
  keycloakClientId: 'platform',
  ncsTicketUrl: 'https://nimmsta.atlassian.net/browse',
  USER_KEY: 'user_object',
  defaultConfigurationVersion: 7,
};
